import UnderlineCta from './UnderlineCta';

export { type UnderlineCtaProps } from './UnderlineCta';
export default UnderlineCta;
